export type QueryKeysType = [string, string];

export const getCompanyInfoKeys = (
  companyId: string,
  businessAccountId: string
): QueryKeysType => [companyId, businessAccountId];

export default getCompanyInfoKeys;
